import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './redux/store';
import { ToastContainer } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css";
import './i18n'
import { BrowserRouter } from 'react-router-dom';
import './helper/axios-config.js'
import { AuthProvider } from "react-oidc-context";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* HR - provider is necessary to use react-redux */}
    <Provider store={store}>
      <PersistGate loading={null } persistor={persistor}>
        <BrowserRouter>
        <App />
        </BrowserRouter>
        {/* HR - toast container comes from react-toastify and shows any toasts we create */}
        <ToastContainer
          position="bottom-center"
          autoClose={2000}
          hideProgressBar={true}
          closeButton={false}
          theme="colored"
          icon={false}
        />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
